<template>
  <div class="logistics">
    <ul>
      <li class="mc-mb-20"><span class="gray9-text">配送企业：</span>韵达快递</li>
      <li><span class="gray9-text">快递单号：</span>{{logisticsData.number}}</li>
    </ul>
    <div class="logist-list">
      <div class="logist-list_item" v-for="(item, index) in logisticsData.infos" :key="index">
        <div>{{item.context}}</div>
        <p>{{item.time}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['logisticsData'],
  data () {
    return {
    };
  },

  // components: {},

  // computed: {},

  mounted() {
    console.log(this.logisticsData);
  },

  // methods: {}
}

</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.logistics{
  border: 1px solid @eee;
  ul{
    padding: 40px;
    background: @f9;
    font-size: 12px;
    color: @gray6;
    border-bottom: 1px solid @eee;
  }
  .logist-list{
    max-height: 350px;
    padding: 20px 40px;
    overflow-y: auto;
    .logist-list_item{
      padding:0 0 20px 20px;
      position: relative;
      font-size: 12px;
      &:last-child{
        padding-bottom: 0;
      }
      &::after{
        content: "";
        border-right: 1px solid @ccc;
        height: 100%;
        position: absolute;
        left: 0;
        top: 3px;
      }
      &::before{
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: @ccc;
        position: absolute;
        left: -5px;
        top: 3px;
        z-index: 1001;
      }
      &:first-child::before{
        background: @yellow;
        box-shadow: 0 0 6px 0 @yellow;
      }
      div{
        color: @gray6;
        margin-bottom: 5px;
      }
      p{
        color: @gray9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Logistics.vue